import {IInsuraceProduct} from "StateInterface";

export enum EVENT_NAME {
    PRODUCT_VIEWED = "Product Viewed",
    SUB_PRODUCT_VIEWED = "Sub-Product Viewed",
    INSURANCE_WHAT_IS_NOT_COVERED = "Insurance What is not Covered",
    INSURANCE_DOWNLOAD_POLICY = "Insurance Download policy",
    INSURANCE_PROCEED = "Insurance Proceed",
    INSURANCE_FILL_DETAILS = "Insurance Fill Details",
    INSURANCE_PROCEED_TO_PAY = "Insurance Proceed to Pay",
}

export const subProductViewEvent = (product: IInsuraceProduct) => {
    const eventData = {
        "Sub-Product Name": product.productTitle,
        "Sub-Product ID": product.productId,
        "Product": product.productName,
        "Category": product.subCategory,
    };
};

export const insuranceProceedEvent = (subProductName: string) => {
    const eventData = {
        "Sub-Product Name": subProductName,
    };
};

export const fillDetailsEvent = (userDetails: object) => {
};

export const downloadPolicyEvent = (subProductName: string) => {
    const eventData = {
        "Sub-Product Name": subProductName,
    };
};

export const proceedToPayEvent = () => {
};

export const productViewedEvent = (productName: string) => {
    const eventData = {
        Product: productName,
    };
};

export const whatIsCoveredEvent = (subProduct: string) => {
    const eventData = {
        "Sub-Product Name": subProduct,
    };
};
